export default __webpack_public_path__ + "images/Aveeno_logo.png";